
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogIn, TrendingUp, Lock, MapPin, MessageCircle, Instagram, HelpCircle, FileText, RefreshCcw, ShieldCheck } from 'lucide-react';

export const Footer: React.FC = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-slate-950 text-white pt-24 md:pt-32 pb-40 md:pb-20 border-t border-white/5" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 md:gap-20 mb-24">
          <div className="col-span-1 md:col-span-2">
            <div className="flex flex-col gap-6 mb-10">
              <div className="flex flex-col">
                <span className="font-black text-2xl md:text-3xl uppercase tracking-tighter">gizrabbitland.com</span>
                <span className="text-[11px] md:text-[12px] font-black text-indigo-400 uppercase tracking-[0.3em] mt-1">Official Tiket Booking</span>
              </div>
              <p className="text-slate-400 text-sm md:text-lg leading-relaxed max-w-lg font-medium">
                Pusat reservasi tiket digital resmi untuk Glow Interactive Zoo dan Rabbits in Wonderland. Platform terpercaya untuk akses liburan tanpa hambatan di Surabaya.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
              <div className="space-y-5">
                <h4 className="text-[11px] font-black uppercase tracking-[0.3em] text-indigo-500 flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-indigo-500 rounded-full"></div> Glow Interactive Zoo Socials
                </h4>
                <div className="flex flex-col gap-3">
                  <a href="https://www.instagram.com/giz.park" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors group">
                    <div className="p-2 bg-white/5 rounded-lg group-hover:bg-indigo-600 transition-colors"><Instagram className="w-5 h-5" /></div> <span className="text-sm font-bold">@giz.park</span>
                  </a>
                  <a href="https://www.tiktok.com/@giz.park" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors group">
                    <div className="p-2 bg-white/5 rounded-lg group-hover:bg-indigo-600 transition-colors"><MessageCircle className="w-5 h-5" /></div> <span className="text-sm font-bold">TikTok @giz.park</span>
                  </a>
                </div>
              </div>
              <div className="space-y-5">
                <h4 className="text-[11px] font-black uppercase tracking-[0.3em] text-orange-500 flex items-center gap-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div> Rabbits in Wonderland Socials
                </h4>
                <div className="flex flex-col gap-3">
                  <a href="https://www.instagram.com/rabbitswonderlandsby" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors group">
                    <div className="p-2 bg-white/5 rounded-lg group-hover:bg-orange-600 transition-colors"><Instagram className="w-5 h-5" /></div> <span className="text-sm font-bold">@rabbitswonderlandsby</span>
                  </a>
                  <a href="https://www.tiktok.com/@rabbitswonderlandsby" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors group">
                    <div className="p-2 bg-white/5 rounded-lg group-hover:bg-orange-600 transition-colors"><MessageCircle className="w-5 h-5" /></div> <span className="text-sm font-bold">TikTok @rabbitswonderlandsby</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <nav aria-label="Quick Links">
            <h4 className="font-black text-[11px] md:text-[12px] uppercase tracking-[0.4em] text-slate-600 mb-10">Resources</h4>
            <ul className="space-y-5 text-sm font-bold text-slate-400">
              <li><Link to="/faq" className="hover:text-white transition-all flex items-center gap-4 group"><HelpCircle className="w-5 h-5 text-indigo-500 group-hover:rotate-12 transition-transform" /> Pusat Bantuan FAQ</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-all flex items-center gap-4 group"><FileText className="w-5 h-5 text-indigo-500 group-hover:rotate-12 transition-transform" /> Syarat Layanan</Link></li>
              <li><Link to="/refund" className="hover:text-white transition-all flex items-center gap-4 group"><RefreshCcw className="w-5 h-5 text-indigo-500 group-hover:rotate-12 transition-transform" /> Kebijakan Pembatalan</Link></li>
              <li className="pt-4 border-t border-white/5"></li>
              <li><Link to="/login" className="hover:text-white transition-all flex items-center gap-4 group"><Lock className="w-5 h-5 text-indigo-500 group-hover:rotate-12 transition-transform" /> Staff Portal</Link></li>
              <li><button onClick={() => navigate('/partner')} className="hover:text-white transition-all text-sm font-bold flex items-center gap-4 group"><TrendingUp className="w-5 h-5 text-indigo-500 group-hover:rotate-12 transition-transform" /> Partner Access</button></li>
            </ul>
          </nav>

          <div>
            <h4 className="font-black text-[11px] md:text-[12px] uppercase tracking-[0.4em] text-slate-600 mb-10">Official Base</h4>
            <ul className="space-y-6 text-sm md:text-base text-slate-400 font-bold">
              <li className="flex gap-5 uppercase tracking-widest text-[11px] md:text-[13px] leading-relaxed"><MapPin className="w-6 h-6 text-emerald-500 shrink-0" /> Area Kebun Binatang Surabaya, Jawa Timur</li>
              <li className="flex gap-5 uppercase tracking-widest text-[11px] md:text-[13px]"><MessageCircle className="w-6 h-6 text-indigo-500 shrink-0" /> Layanan Admin 24/7</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-12 flex flex-col md:flex-row justify-between items-center gap-10">
          <p className="text-[10px] md:text-[11px] text-slate-500 font-black uppercase tracking-[0.4em] text-center md:text-left">&copy; {new Date().getFullYear()} GIZRABBITLAND.COM • OFFICIAL TIKET BOOKING. ALL RIGHTS RESERVED.</p>
          <div className="flex gap-8 items-center opacity-60">
            <ShieldCheck className="w-5 h-5 text-slate-500" />
            <span className="text-[9px] font-black uppercase tracking-[0.4em] text-slate-500">Encrypted Gateway</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
